jQuery( document ).ready(function() {
    //IS PRODUCT DETAIL PAGE
    if(jQuery('#custom-bundle-template-product').length > 0){
        console.log('product Detail Page');
        let productID = ($('#custom-bundle-template-product').attr('data-product-id'));
        console.log(productID);
        getBundle(productID);
    }


});
function getBundle(productID){
    //var url = 'https://bundle-simplified.demoworkplace.com/v2/bdt-bundle-app-store.myshopify.com?productID=5419710840998';
    var url = 'https://ad06ce94997c18f717ed250c9854b426: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@bdt-bundle-app-store.myshopify.com/admin/themes.json';
    $.ajax
    ({
        type: "GET",
        url: url,
        //dataType: 'json',
        crossDomain: true,
        data: {'productID': productID},
        //beforeSend: function (xhr) {
        //    xhr.setRequestHeader('X-SHOPIFY-DOMAIN', 'bdt-bundle-app-store.myshopify.com/');
        //},
        success: function (data) {
            //DISPLAY HTML RECEIVE FROM BUNDLE APP SERVER
            console.log(data);
        }
    });
}